export default "__VITE_ASSET__BZPPwmSE__"